var j = Object.defineProperty, l = Object.defineProperties;
var D = Object.getOwnPropertyDescriptors;
var o = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, p = Object.prototype.propertyIsEnumerable;
var u = (t, e, r) => e in t ? j(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, m = (t, e) => {
  for (var r in e || (e = {}))
    d.call(e, r) && u(t, r, e[r]);
  if (o)
    for (var r of o(e))
      p.call(e, r) && u(t, r, e[r]);
  return t;
}, y = (t, e) => l(t, D(e));
var v = (t, e) => {
  var r = {};
  for (var n in t)
    d.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && o)
    for (var n of o(t))
      e.indexOf(n) < 0 && p.call(t, n) && (r[n] = t[n]);
  return r;
};
import { j as I } from "../../../jsx-runtime-c20f6c15.mjs";
import { forwardRef as L, useRef as P, useEffect as b } from "react";
import g from "clsx";
const w = "_container_12d5y_1", K = "_disabled_12d5y_1", _ = {
  container: w,
  disabled: K
};
function N(O, c) {
  var f = O, { children: t, onClick: e, disabled: r, className: n } = f, E = v(f, ["children", "onClick", "disabled", "className"]);
  const i = P(null);
  b(() => {
    function s(h) {
      !r && h.key === "Enter" && (e == null || e());
    }
    const a = i.current;
    return a == null || a.addEventListener("keypress", s), () => {
      a == null || a.removeEventListener("keypress", s);
    };
  }, [e, r]);
  function x(s) {
    s.stopPropagation(), r || e == null || e();
  }
  return /* @__PURE__ */ I(
    "div",
    y(m({
      ref: (s) => {
        i.current = s, c && (c.current = s);
      },
      onClick: x,
      role: "presentation",
      className: g(
        _.container,
        {
          [_.disabled]: r
        },
        n
      )
    }, E), {
      children: t
    })
  );
}
const B = L(N);
export {
  B as default
};
